{
  "puan": {
    "Puan Tanımları": "Score Definitions",
    "Baslik": "Score Definitions",
    "Puan Adı": "Score Name",
    "Puan (%)": "Score (%)",
    "Aralık ve Komisyon Tanımları": "Range and Commission Definitions",
    "Yeni Aralık": "New Range",
    "Aralıkları Kopyala": "Copy Ranges",
    "Unvan": "Title",
    "Min %": "Min %",
    "Max %": "Max %",
    "Komisyon %": "Commission %",
    "İşlemler": "Actions",
    "Puan Ekle": "Add Score",
    "Puan Güncelle": "Update Score",
    "Aralık Ekle": "Add Range",
    "Aralık Güncelle": "Update Range",
    "Kaydet": "Save",
    "Güncelle": "Update",
    "İptal": "Cancel",
    "Sil": "Delete",
    "Puan Tanımını Sil": "Delete Score Definition",
    "Aralık Sil": "Delete Range",
    "bu puan tanımını ve bağlı tüm aralıkları silmek istediğinize emin misiniz?": "are you sure you want to delete this score definition and all associated ranges?",
    "Bu aralık tanımını silmek istediğinize emin misiniz?": "Are you sure you want to delete this range definition?",
    "Lütfen bir puan tanımı seçiniz": "Please select a score definition",
    "için aralıkları başka bir puandan kopyala:": "copy ranges from another score for:",
    "Min Yüzde": "Min Percentage",
    "Max Yüzde": "Max Percentage",
    "Komisyon (%)": "Commission (%)",
    "Unvan Seçiniz": "Select Title",
    "Kaynak Puan": "Source Score",
    "Puan Seçiniz": "Select Score",
    "Kopyala": "Copy",
    "Personel Unvan": "Personnel Title",
    "Data Yenile": "Refresh Data",
    "Komisyon": "Commission",
    "Düzeltme": "Edit",
    "Ara": "Search",
    "Komisyon Hesaplanmaz": "No Commission Calculated",
    "LutfenUnvanSeciniz": "Please select a title first"
  }
}
